import Seo from "@/lib/Seo";
import InquiryForm from "@/components/InquiryForm";
import { useQuote } from "@/lib/quote";
import { FadeUp } from "@/lib/motion";
import Breadcrumbs from "@/components/Breadcrumbs";

export default function QuotePage() {
  const { items, palette } = useQuote();
  return (
    <div className="pt-[72px]">
      <Seo
        title="Request a Quote — Tell Us About Your Celebration | Marble & Veil"
        description="Build your quote list and tell us about your celebration. Pricing is confirmed in a tailored proposal — submitting an inquiry never reserves a date."
        path="/quote"
      />
      <section className="mx-auto max-w-4xl px-5 py-16 sm:px-8 lg:py-24">
        <Breadcrumbs trail={[["Home", "/"], ["Request a Quote"]]} />
        <FadeUp>
          <h1 className="mt-6 font-display text-5xl leading-[1.05] text-ink sm:text-6xl">Request a Quote</h1>
          <p className="mt-5 max-w-xl leading-relaxed text-smoke">
            One low-friction inquiry for everything you have gathered. If your quote list is empty, the
            form works exactly the same — interests tell us where to begin.
          </p>
        </FadeUp>

        <FadeUp delay={0.1}>
          <div className="mt-10 border border-ink/10 bg-parch p-6 text-sm leading-relaxed text-smoke" data-testid="quote-expectations">
            <p className="font-display text-lg italic text-ink">What happens next</p>
            <p className="mt-2">
              Pricing is confirmed in your proposal — this form shows no subtotal because none of this
              is one-size-fits-all. Submitting does not reserve a date or commit you to a purchase.
            </p>
          </div>
        </FadeUp>

        <div className="mt-12">
          <InquiryForm mode="quote" />
        </div>

        {items.length === 0 && !palette && (
          <p className="mt-10 text-sm text-smoke" data-testid="quote-empty-hint">
            Tip: add pieces from the{" "}
            <a href="/shop" className="border-b border-olive text-olive">shop</a>
            {" "}or build a{" "}
            <a href="/collections" className="border-b border-olive text-olive">collection</a>
            {" "}first — your selections will be waiting here.
          </p>
        )}
      </section>
    </div>
  );
}
